import React from 'react';
import MindUpAdminAccountSettingHeader from './MindUpAdminAccountSettingHeader';
import styled from 'styled-components';
import { Body3MediumButton, Body5Medium, Title2SemiBold } from 'styles/Global/typography';
import { BorderColor, TextColor, WarningColor } from 'styles/Global/colorSemantic';
import IconWarningFill from 'assets/Icons/Check/IconWarningFill';
import { useExistUserQuery } from 'api/Queries/User/useExistUserQuery';
import { MobileBasicInputWithLabel } from 'components/Input/BasicInput';
import ConfirmDialogueHorizonLeft from 'components/DesignSystem/MobileConfirmDialogue/ConfirmDialogueHorizonLeft';
import useToggle from 'hooks/CustomHooks/useToggle';
import { useNavigate } from 'react-router-dom';
import { mindupAdminMobilePaths } from 'constants/path';

const MindUpAdminSettingAccountPage = () => {
    const navigate = useNavigate();
    const { data: existUserData, isLoading: existUserLoading, refetch: refetchexistUserData } = useExistUserQuery();

    const [onLogoutModal, setOnLogoutModal] = useToggle();

    const handleLogout = () => {
        localStorage.clear();
        navigate(mindupAdminMobilePaths.login, { replace: true });
    };

    return (
        <Layout>
            {onLogoutModal && (
                <ConfirmDialogueHorizonLeft
                    title='로그아웃 하시겠습니까?'
                    content='상담 확인과 처리를 위해, 로그아웃 후에는 재로그인이 필요합니다.'
                    firstButton='취소'
                    secondButton='로그아웃'
                    clickFirstButton={setOnLogoutModal}
                    clickSecondButton={handleLogout}
                />
            )}
            <MindUpAdminAccountSettingHeader />
            <TitleContainer>
                <Title>계정 정보</Title>
                <NotiTextContainer>
                    <IconWarningFill width='16px' height='16px' />
                    <span>정보 변경은 현재 PC버전에서만 가능합니다.</span>
                </NotiTextContainer>
            </TitleContainer>
            <InputContianer>
                <MobileBasicInputWithLabel label='이메일 아이디' value={existUserData?.email!} id='email' disabled={true} />
                <MobileBasicInputWithLabel label='이름' value={existUserData?.name!} id='name' disabled={true} />
                <MobileBasicInputWithLabel label='연락처' value={existUserData?.mobile!} id='mobile' disabled={true} />
            </InputContianer>
            <Divider />
            <ClickArea onClick={setOnLogoutModal}>계정 로그아웃</ClickArea>
        </Layout>
    );
};

export default MindUpAdminSettingAccountPage;

const Layout = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100vh;
    height: auto;
    padding-top: 56px;
`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 20px 16px 32px;
    width: 100%;
`;

const Title = styled(Title2SemiBold)``;

const NotiTextContainer = styled(Body5Medium)`
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${WarningColor.color_warning_normal};
`;

const InputContianer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 36px;
    width: 100%;
    padding: 0 16px;
`;

const Divider = styled.div`
    width: calc(100% - 24px);
    height: 1px;
    background-color: ${BorderColor.color_border_weak};
    margin: 40px 0 16px 0;
`;

const ClickArea = styled(Body3MediumButton)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 135px;
    height: 44px;
    color: ${TextColor.color_text_light};
`;
